// libraries.
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { monserratSemiBold, robotoRegular, scarpaGray400 } from '@habitech/shared';

// components.
import { CoordinateInputs } from './CoordinateInputs';
import { Line } from '@shared/styles';
import { LoteIdWarning } from '@shared/LoteIdWarning/LoteIdWarning';

// hooks.
import { useGeoreferencingWebSocket } from '../hooks';
import { useGetLeadDetailInfoQuery } from '@domains/lead-detail';

// selectors.
import {
  getSelectedBusinessLine,
  getSelectedNid,
  resetCoordinates,
} from '../store/slices/georeferencing-slice';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';

export const FieldsToCorrect = () => {
  const dispatch = useDispatch();
  const selectedBusinessLine = useSelector(getSelectedBusinessLine);
  const selectedNid = useSelector(getSelectedNid);
  const country = useSelector(getCountry);
  const [hasUserInput, setHasUserInput] = useState(false);

  const { data: leadDetail } = useGetLeadDetailInfoQuery(
    { country, nid: selectedNid || '' },
    { skip: !selectedNid }
  );

  const { sendGeoreferencing, isLoading, canSend } = useGeoreferencingWebSocket(
    {
      onSuccess: () => {
        dispatch(resetCoordinates());
        setHasUserInput(false);
      },
    }
  );

  const isDisabled = !canSend || !hasUserInput || !selectedBusinessLine || isLoading;

  return (
    <div className="d-flex flex-column h-100">
      <div className="p-3" style={{ backgroundColor: '#f9f9f9' }}>
        <h5
          style={{
            fontFamily: monserratSemiBold,
            fontSize: '16px',
            margin: 0,
          }}
        >
          Campos a corregir
        </h5>
        {selectedNid && (
          <p
            style={{
              fontFamily: robotoRegular,
              fontSize: '13px',
              color: scarpaGray400,
              margin: '4px 0 0 0',
            }}
          >
            NID: {selectedNid}
          </p>
        )}
        {selectedNid && leadDetail && (
          <LoteIdWarning loteId={leadDetail.location?.lote_id ?? null} />
        )}
      </div>
      <div className="p-3 flex-grow-1" style={{ overflowY: 'auto' }}>
        <CoordinateInputs onInputChange={setHasUserInput} />
      </div>
      <div className="d-flex flex-column gap-3 px-3 pb-3">
        <Line />
        {!selectedBusinessLine && (
          <p
            style={{
              fontFamily: robotoRegular,
              fontSize: '13px',
              color: scarpaGray400,
              margin: 0,
              textAlign: 'center',
            }}
          >
            Selecciona una línea de negocio para continuar
          </p>
        )}
        <div className="d-flex">
          <Button
            className="w-100 btn-habi"
            type="button"
            onClick={sendGeoreferencing}
            disabled={isDisabled}
          >
            {isLoading ? 'Guardando...' : 'Guardar'}
          </Button>
        </div>
      </div>
    </div>
  );
};
